//Globally allow a booking to come from the side of the screen to view, edit, or cancel
import moment from "moment";

export const setCurrentVehicle = (vehicle) => (dispatch) => {
    dispatch({ type: "SET_CURRENT_VEHICLE", payload: vehicle })
}

export function openPullout(booking, action) {
    if (action == "edit") {
        return function(dispatch) {
            dispatch({type: 'SET_BOOKING_EDIT', payload: booking});
        }
    } else if (action == "new") {
        return function(dispatch) {
            dispatch({type: 'SET_BOOKING_NEW', payload: booking});
        }
    } else {
        return function(dispatch) {
            dispatch({type: "SET_BOOKING", payload: booking})
        }
    }
}

export const updateCurrentBooking = (booking) => (dispatch) => {
    dispatch({ type: "UPDATE_CURRENT_BOOKING", payload: booking })
}

export function closePullout() {
    return function(dispatch) {
        dispatch({type: "CLOSE_PULLOUT"})
    }
}

export const endPulloutEdit = () => (dispatch) => {
    dispatch({ type: "END_PULLOUT_EDIT" })
}

//For the booking calendar 
export function setNextPage(page) {
    return function(dispatch) {
        dispatch({type: "UPDATE_BOOKING_NEXT_PAGE", payload: page})
    }
}

export function setList(type, list) {
    return function(dispatch) {
        dispatch({
            type: type, 
            payload: list
        })
    }
}

export function setDate(date) {
    return function(dispatch) {
        dispatch({
            type: "SET_CURRENT_DATE",
            payload: date
        })
    }
}

export function setOverlay(type, data) {
    return function(dispatch) {
        dispatch({
            type: type,
            payload: data
        })

        if ("media" in data && "complete" in data.media) {
            dispatch({type: "SET_ORGANIZED_MEDIA", payload: sortMedia(data.media.complete)})
        }
    }
}

export function configureBookingDictionary(bookings, holidays, organized_bookings) {
    return function(dispatch) {
        var vehicles = Object.keys(bookings)
        var booking_dictionary = organized_bookings
        for (var i = 0; i < vehicles.length; i++) {
            if (! (vehicles[i] in booking_dictionary)) {
                booking_dictionary[vehicles[i]] = {}
            }

            var open_weekend = 0
            var vmh_open = 9
            var vmh_close = 17
            var post_turn_hours = 1
            var post_turn_days = 0
            var pre_turn_hours = 1
            var pre_turn_days = 0

            for (var k = 0; k < bookings[vehicles[i]].length; k++) {
                var current_booking = bookings[vehicles[i]][k]

                var sh_vmh_hours = current_booking.sh_vmh_relation.filter(function(sh_vmh_relation) {
                    return (sh_vmh_relation.VMH_ID == current_booking.VMH_ID);
                });

                if (sh_vmh_hours[0].Hours_Diff === 1) {
                    open_weekend = sh_vmh_hours[0].Open_Weekend
                    vmh_open = sh_vmh_hours[0].Hours_Week_Start
                    vmh_close = sh_vmh_hours[0].Hours_Week_End
                    post_turn_hours = sh_vmh_hours[0].Turn_Post_Hours
                    post_turn_days = sh_vmh_hours[0].Turn_Post
                    pre_turn_hours = sh_vmh_hours[0].Turn_Pre_Hours
                    pre_turn_days = sh_vmh_hours[0].Turn_Pre
                } else {
                    open_weekend = current_booking.vmh.Open_Weekend
                    vmh_open = current_booking.vmh.Hours_Week_Start
                    vmh_close = current_booking.vmh.Hours_Week_End
                    post_turn_hours = current_booking.vmh.Turn_Post_Hours
                    post_turn_days = current_booking.vmh.Turn_Post
                    pre_turn_hours = current_booking.vmh.Turn_Pre_Hours
                    pre_turn_days = current_booking.vmh.Turn_Pre
                }

                var beginning_year = moment(current_booking.Start_Date, "YYYY-MM-DD").get("year")
                var beginning_day = moment(current_booking.Start_Date, "YYYY-MM-DD")
                var beginning_time = parseInt(current_booking.Release_Time?.split(":")[0])
                var beginning_flag = true;

                // move the beginning day based on no of turn over days
                beginning_day.subtract(pre_turn_days, 'days');

                // if turn over time makes the day unavailable, make the beginning day a day prior to current days
                if (beginning_time - pre_turn_hours < vmh_open) {
                    beginning_day.subtract(1, 'days')
                }

                // if current beginning day (after adding turn over days/times) is a weekend or holiday, move the beginning day appropriately
                while(beginning_flag) {
                    // check if vmh is open on weekends, if it is check if beginning date is saturday or sunday, move beginning day to a day prior
                    if(!open_weekend && (beginning_day.get('day') === 6 || beginning_day.get('day') === 0)) {
                        beginning_day.subtract(1, 'days')
                    } 
                    // check if any holidays exist for given vehicle and check if beginning date is a holiday, if it is move beginning day to a day prior
                    else if(vehicles[i] in holidays && holidays[vehicles[i]].length > 0 && holidays[vehicles[i]].includes(beginning_day.format("YYYY-MM-DD"))) {
                        beginning_day.subtract(1, 'days')
                    }
                    // break out of the while loop
                    else {
                        beginning_flag = false;
                    }
                }

                var ending_year = moment(current_booking.End_Date, "YYYY-MM-DD").get("year")
                var ending_day = moment(current_booking.End_Date, "YYYY-MM-DD")
                var ending_time = parseInt(current_booking.Return_Time?.split(":")[0])
                var ending_flag = true;

                // move the ending day based on no of turn over days
                ending_day.add(post_turn_days, 'days')

                // if turn over time makes the day unavailable, make the ending day a day after the current ending day
                if (ending_time + post_turn_hours > vmh_close) {
                    ending_day.add(1, 'days')
                }

                // if current ending day (after adding turn over days/times) is a weekend or holiday, move the ending day appropriately
                while(ending_flag) {
                    // check if vmh is open on weekends, if it is check if ending date is saturday or sunday, move ending day to a day after current ending day
                    if(!open_weekend && (ending_day.get('day') === 6 || ending_day.get('day') === 0)) {
                        ending_day.add(1, 'days')
                    } 
                    // check if any holidays exist for given vehicle and check if ending date is a holiday, if it is move ending day to a day after the current ending day
                    else if(vehicles[i] in holidays && holidays[vehicles[i]].length > 0 && holidays[vehicles[i]].includes(ending_day.format("YYYY-MM-DD"))) {
                        ending_day.add(1, 'days')
                    }
                    // break out of the while loop
                    else {
                        ending_flag = false;
                    }
                }

                beginning_day = beginning_day.dayOfYear()
                ending_day = ending_day.dayOfYear()

                for (var year = beginning_year; year <= ending_year; year++) {
                    if (! (year in booking_dictionary[vehicles[i]])) {
                        booking_dictionary[vehicles[i]][year] = {}
                    }
                }
    
                //The booking bleeds into the next year (Ex. starts 2018 ends 2019, the beginning day may be 364 but ending day may be 3)
                if (ending_day < beginning_day) {
                    for (var day = beginning_day; day <= 365; day++) {
                        if (! (day in booking_dictionary[vehicles[i]][beginning_year])) {
                            booking_dictionary[vehicles[i]][beginning_year][day] = {}
                        }
    
                        booking_dictionary[vehicles[i]][beginning_year][day][current_booking.BOOK_ID] = current_booking
                    }
    
                    for (var day = 1; day <= ending_day; day++) {
                        if (! (day in booking_dictionary[vehicles[i]][ending_year])) {
                            booking_dictionary[vehicles[i]][ending_year][day] = {}
                        }
    
                        booking_dictionary[vehicles[i]][ending_year][day][current_booking.BOOK_ID] = current_booking
                    }
                } else {
                    for (var day = beginning_day; day <= ending_day; day++) {
                        if (! (day in booking_dictionary[vehicles[i]][beginning_year])) {
                            booking_dictionary[vehicles[i]][beginning_year][day] = {}
                        }
    
                        booking_dictionary[vehicles[i]][beginning_year][day][current_booking.BOOK_ID] = current_booking
                    }
                }
            }
        }
    
        dispatch({type: "SET_ORGANIZED_BOOKINGS_LIST", payload: booking_dictionary})
    }
}

function sortMedia(completed_media) {
    var score = 0;
    var amount_rated_media = 0;
    var media_breakdown = [
        {name: 'Negative', Bad: 0},
        {name: 'Somewhat Negative', Poor: 0},
        {name: 'Neutral', Neutral: 0},
        {name: 'Somewhat Positive', Good: 0},
        {name: 'Positive', Excellent: 0}
    ];
    
    for (var i = 0; i < completed_media.length; i++ ) {
        if (completed_media[i].Rating !== null) {
            var score = score + completed_media[i].Rating;
            var amount_rated_media = amount_rated_media + 1;
    
            if (completed_media[i].Rating === 0) {
                media_breakdown[0].Negative = media_breakdown[0].Negative + 1
            } else if (completed_media[i].Rating === 25) {
                media_breakdown[1]['Somewhat Negative'] = media_breakdown[1]['Somewhat Negative'] + 1
            } else if (completed_media[i].Rating === 50) {
                media_breakdown[2].Neutral = media_breakdown[2].Neutral + 1
            } else if (completed_media[i].Rating === 75) {
                media_breakdown[3]['Somewhat Positive'] = media_breakdown[3]['Somewhat Positive'] + 1
            } else if (completed_media[i].Rating === 100) {
                media_breakdown[4].Positive = media_breakdown[4].Positive + 1
            } 
        }
    }
    
    return {
        media_breakdown: media_breakdown,
        media_average: {average: score / amount_rated_media, amount_ratings: amount_rated_media}
    }
}

export function setFilters(previous_filters, sort_direction, sort_filter) {
    return function(dispatch) {
        dispatch({
            type: "UPDATE_FILTER",
            payload: {
                sort_direction: sort_direction,
                sort_filter: sort_filter,
                previous_filters: previous_filters
            }
        })
    }
}

export const createInventory = () => (dispatch) => {
    dispatch({ type: "CREATE_INVENTORY" })
}

export const updateInventory = (Inventory) => (dispatch) => {
    dispatch({ type: "UPDATE_INVENTORY", payload: Inventory })
}

export const cleanInventory = () => (dispatch) => {
    dispatch({ type: "CLEAN_INVENTORY" })
}
